import { lazy } from 'react';

export const ExamInvitationList = lazy(() => import('./ExamInvitationList'));
export const AddExamInvitation = lazy(() => import('./AddExamInvitation'));
